export const SET_WORKORDER_QUEUE = 'SET_WORKORDER_QUEUE'
export const SET_TECH_QUEUE = 'SET_TECH_QUEUE'
export const SET_TOOL_QUEUE = 'SET_TOOL_QUEUE'
export const SET_DISPATCH_LOG = 'SET_DISPATCH_LOG'
export const SET_QUEUE = 'SET_QUEUE'
export const FILTER_WORKORDER_QUEUE = 'FILTER_WORKORDER_QUEUE'
export const FILTER_TECH_QUEUE = 'FILTER_TECH_QUEUE'
export const FILTER_TOOL_QUEUE = 'FILTER_TOOL_QUEUE'
export const SET_BREAKDOWN_SUMMARY = 'SET_BREAKDOWN_SUMMARY'
export const SET_DAYS = 'SET_DAYS'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_SELECTED = 'SET_SELECTED'



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/types.js